import { createContext, useContext, type ReactNode } from 'react';
import { allModulesEnabled, type AccountModules } from '@evo-hub/shared';

export interface SessionInfo {
  displayName: string | null;
  accountName: string | null;
  // Fase 2 — null hasta que /api/auth/me resuelva (mismo momento que
  // displayName/accountName). El frontend nunca decide solo con esto — es
  // para ocultar UI que un member no puede usar, el 403 real vive en el
  // backend (requireOwner()).
  role: 'owner' | 'member' | null;
  // Registro público (2026-08-05) — DISTINTO de `role` (ese es por cuenta).
  // Administra la plataforma entera (aprueba/rechaza solicitudes de alta de
  // cualquier cuenta) — mismo criterio: solo gatea UI, el 403 real vive en
  // requirePlatformAdmin.
  isPlatformAdmin: boolean;
  // Panel de plataforma (2026-08-17) — módulos habilitados de la cuenta.
  // Mismo criterio que los dos de arriba: solo gatea UI (qué se ve en el
  // sidebar y qué rutas existen). El 403/404 real lo dan requireModule y
  // requirePublicModule en el backend, así que una pestaña vieja o una URL
  // tipeada a mano no pasa aunque el frontend tenga un estado desactualizado.
  modules: AccountModules;
}

const SessionCtx = createContext<SessionInfo>({ displayName: null, accountName: null, role: null, isPlatformAdmin: false, modules: allModulesEnabled() });

export function SessionProvider({ children, value }: { children: ReactNode; value: SessionInfo }) {
  return <SessionCtx.Provider value={value}>{children}</SessionCtx.Provider>;
}

export function useSession() {
  return useContext(SessionCtx);
}
